import React, { useState } from "react";
import { Fragment, useEffect, useContext } from "react";
import { ContainerNew, SubMenu } from "../Layout";
import { PostApi156 } from "../../modules/network/padoPost";
import { AppContext } from "./../../components/AppProvider";
import styled from "styled-components";
import { getCookie, setCookie } from "./../../modules/utils/cookie";
import { PostApi157 } from "./../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { checkNum10 } from "../../modules/utils/CheckLogic";
import { InputDivAttch } from "../../components/UI/INPUT/InputDivAttch";

export default (props) => {
  const { phonecfg, cfg } = useContext(AppContext);
  const [timer, setTimer] = useState(180);

  const userInfo = {
    userId: getCookie("userId"),
    userName: getCookie("userName"),
    userBirth: getCookie("userBirth"),
    userTelNo: getCookie("userPhone"),
    gender: getCookie("gender"),
  };

  const checkCertiNo = () => {
    PostApi157(
      phonecfg,
      cfg,
      userInfo.userId,
      userInfo.userName,
      userInfo.userBirth,
      userInfo.userTelNo,
      $("input[name=certiNo]").val()
    )
      .then((res) => {
        console.log("res :: ", res);
        if (res.resultCode === "000") {
          // 비밀번호 변경 페이지로 이동(인증번호 전달)
          if (res.result === 0) {
            // 시간초과 or 마지막으로 전송된 인증번호가 아님
            alert("잘못된 인증번호 입니다.");
          } else {
            _O.Open(
              "/membership/changePwd/" +
                userInfo.userId +
                "/" +
                $("input[name=certiNo]").val()
            );
          }
        } else {
          alert("잠시후 다시 시도 부탁드립니다.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          checkCertiNo();
        }}
      >
        확인
      </BtnNext>
    </div>
  );

  const requestCertiNo = () => {
    PostApi156(
      phonecfg,
      cfg,
      userInfo.userId,
      userInfo.userName,
      userInfo.userBirth,
      userInfo.userTelNo,
      userInfo.gender
    )
      .then((res) => {
        console.log("res :: ", res);
      })
      .catch((err) => {
        console.log(err);
      });

    // setTimer(180);
    setCookie("timer", 180);
  };

  useEffect(() => {
    const timerEvent = setInterval(() => {
      if (getCookie("timer") > 0) {
        setCookie("timer", getCookie("timer") - 1);
        setTimer(getCookie("timer") - 1);
      }
    }, 1000);
    return () => clearInterval(timerEvent);
  }, []);
  return (
    <Fragment>
      <ContainerNew
        Title={"본인인증"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        bottom={bottom}
        isMain={true}
      >
        <Contents>
          <SubTitleCpnt />

          {/* input area */}
          <div>
            <InputDivAttch
              type="text"
              name="certiNo"
              placeholder="인증번호를 입력하세요"
              style={{ marginBottom: "16px", backgroundColor: "#f7f7f7", borderRadious: "8px" }}
              requestCertiNo={requestCertiNo}
            />
          </div>
        </Contents>
      </ContainerNew>
    </Fragment>
  );
};

export const returnTime = (time) => {
  let min = time / 60;
  let sec = time % 60;

  return checkNum10(parseInt(min)) + ":" + checkNum10(sec);
};

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SubTitleCpnt = () => {
  return (
    <Fragment>
      <SubTitle>인증번호</SubTitle>
      <div style={{ padding: "8px 0px" }}>
        <p>인증번호를 확인하세요</p>
      </div>
    </Fragment>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;
